<template>
  <v-sheet color="transparent" width="100%" height="100%">
    <v-sheet
      v-if="loading"
      class="d-flex justify-center align-center"
      height="100%"
      width="100%"
      color="transparent"
    >
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </v-sheet>

    <v-sheet v-else>
      <Title>{{ item.title }}</Title>

      <v-container class="pt-8 pb-10 pt-lg-12 pb-lg-16 institutional">
        <v-row justify="center" v-if="item.title">
          <v-col cols="12">
            <img
              :src="files + item.img + '?resize=1&w=800'"
              :alt="item.title"
              v-if="item.img"
              class="d-block featured-img"
            />

            <div
              class="
                primary--text
                text--lighten-1 text-body-1 text-md-h6
                font-weight-regular
                pt-8
                pb-10
                pt-lg-12
                pb-lg-16
              "
              v-html="item.text"
              v-if="item.text"
            ></div>
          </v-col>
        </v-row>
        <div v-else>
          <v-alert prominent class="primary white--text">
            <v-row align="center">
              <v-col class="grow">
                <v-icon class="primary--text text--darken-3 mb-1 mr-2">
                  fa fa-exclamation-circle
                </v-icon>

                Nenhum conteúdo adicionado até o momento.
              </v-col>

              <v-col class="shrink">
                <v-btn class="secondary white--text" to="/">
                  Página Inicial
                </v-btn>
              </v-col>
            </v-row>
          </v-alert>
        </div>
      </v-container>
    </v-sheet>
  </v-sheet>
</template>

<script>
import Title from "../widgets/Title.vue";

const _config = {
  mod: "about",
};

export default {
  data: () => ({
    loading: true,
    index: null,
  }),
  computed: {
    item() {
      if (!this.$rest(_config.mod).item) return "";

      if (
        this.$rest(_config.mod).item.img &&
        this.$rest(_config.mod).item.img.list
      ) {
        const images = [];

        this.$rest(_config.mod).item.img.list.map(({ path }) => {
          if (path !== this.$rest(_config.mod).item.img.featured.path)
            images.push(this.files + path);
        });

        this.$rest(_config.mod).item.img.list = images;
      }

      return this.$rest(_config.mod).item;
    },
  },
  mounted() {
    this.$rest(_config.mod)
      .get({
        save: (state, data) => (state.item = data),
      })
      .then(() => (this.loading = false));
  },
  components: {
    Title,
  },
};
</script>

<style lang="scss" scoped>
.institutional {
  .featured-img {
    width: 100%;
  }
  .institutional-text {
    font-size: 16px;
    line-height: 24px;
  }
}
</style>
